
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import config from '@/config.json';

@Options({
  props: {
    name: String
  },
  computed: {
    ...mapGetters(['getJsonData', 'getGames']),
    showGameInfoBlock() {
      return config.showGameInfoBlock;
    },
    gameData() {
      const games = this.getGames;
      return games.find((game: {name: string}) => game.name === this.name) || {};
    },
    combinedData() {
      const jsonData = this.getJsonData;
      const gameData = this.gameData;

      return {
        rtp: `${jsonData.rtp} ${gameData.rtp.split(';').map((part:string) => `${part}%`).join(' ')}`,
        lines: `${jsonData.lines} ${gameData.lines}`,
        ways: `${jsonData.ways}  ${gameData.ways}`,
        freeSpin: `${jsonData.freeSpin}  ${gameData.freeSpin}`,
        features: `${jsonData.features}  ${gameData.features}`,
        coinSpin: `${jsonData.coinSpin}  ${gameData.coinSpin}`,
        wheels: `${jsonData.wheels}  ${gameData.wheels}`,
        avalanche: `${jsonData.avalanche}  ${gameData.avalanche}`,
        cascade: `${jsonData.cascade}  ${gameData.cascade}`,
        jackpotGame: `${jsonData.jackpotGame}  ${gameData.jackpotGame}`,
        featuresBuy: `${jsonData.featuresBuy}  ${gameData.featuresBuy}`,
      };
    }
  }
})
export default class InfoBlock extends Vue {
}
